import React from 'react';
import {
  Col, Row, Form, FormGroup, ControlLabel
} from 'react-bootstrap';
import Select from 'react-select';
import { mountTable, unmountTable, getTable } from '../../../views/Components/JQueryTable/JQueryTableLogic.jsx';
import JQueryTableComponent from '../../../views/Components/JQueryTable/JQueryTableComponent.jsx';
import { API_ROOT } from '../../../variables/api-config';

const dataTable = {
  headerRow: ["Convocatoria", "Proyecto", "Estado", "Situación", "Responsable", "Sector", "Acciones"],
  footerRow: ["Convocatoria", "Proyecto", "Estado", "Situación", "Responsable", "Sector", "Acciones"]
};
class ListSubTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      convocatoriaFiltro: {value: this.props.convocatorias[0], label: this.props.convocatorias[0]},
      estadoFiltro: {value: 6, label: 'PRE-SELECCIONADA'},
    };
    this.onClickEdit = this.onClickEdit.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.filters = [{name: 'estado', value:'estadoFiltroPreSelection'}, {name: 'convocatoria', value:'convocatoriaFiltroPreselection'}];
    this.onChangeConvocatoriaFilter = this.onChangeConvocatoriaFilter.bind(this);
  }
  componentDidMount() {
    mountTable(API_ROOT + "/incubation/ideas", "preSelectionTab", this.onClickEdit, null, null, null, 8, this.filters);
  }
  componentWillUnmount() {
    unmountTable('preSelectionTab');
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.convocatorias !== nextProps.convocatorias) {
      this.setState({convocatoriaFiltro: {value: nextProps.convocatorias[0], label: nextProps.convocatorias[0]}});
    }
  }
  shouldComponentUpdate() {
    return true;
  }
  onClickEdit(data) {
    this.props.history.push("/incubation/" + data[8] +'/pre-selection'); // ver esto
  }
  applyFilters() {
    const table = getTable('preSelectionTab');
    table.clear();
    table.ajax.reload();
    table.draw();
  }
  onChangeConvocatoriaFilter(item) {
    this.setState({convocatoriaFiltro: item},this.applyFilters);
  }
  render() {
    const convocatoriasList = [];
    this.props.convocatorias.forEach((item) => {
      convocatoriasList.push({value: item, label: item});
    })
    return(
      <div>
        <Form horizontal>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Col componentClass={ControlLabel} md={6} style={{textAlign:'left', paddingTop: '7px'}}>
                  Convocatoria:
                </Col>
                <Col md={6}>
                  <Select
                    placeholder="Seleccione"
                    closeOnSelect={true}
                    name="type"
                    value={this.state.convocatoriaFiltro}
                    options={convocatoriasList}
                    onChange={(value) => this.onChangeConvocatoriaFilter(value)}
                    //onChange={(value) => { this.setState({convocatoriaFiltro: value}, this.applyFilters)}}
                  />
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </Form>
        <input style={{display: 'none'}} type="text" className="estadoFiltroPreSelection" value={JSON.stringify(this.state.estadoFiltro)} disabled />
        <input style={{display: 'none'}} type="text" className="convocatoriaFiltroPreselection" value={JSON.stringify(this.state.convocatoriaFiltro)} disabled />
        <div className="fresh-datatables">
          <JQueryTableComponent dataTable={dataTable} identifier="preSelectionTab" />
        </div>
      </div>
    );
  }
}
export default ListSubTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/PreSelectionComponents/ListSubTab.jsx